import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { UiDrawerComponent } from '@uigy/shared/components/ui-drawer/ui-drawer.component';
import {
  UiDrawerContentHeaderComponent
} from '@uigy/shared/components/ui-drawer/components/ui-drawer-content-header/ui-drawer-content-header.component';
import { UiDrawerSectionComponent } from '@uigy/shared/components/ui-drawer/components/ui-drawer-section/ui-drawer-section.component';
import { ActionButtonVariant } from '@uigy/shared/components/ui-buttons-action-bar/models';
import { FindingsTabQueryParams, TabGroup } from '@uigy/shared/components/tabs/tabs.enums';
import {
  VulnerabilityFindingsSideDrawerService
} from '@uigy/modules/findings/components/findings-side-panel/services/vulnerability-findings-side-drawer.service';
import { PolicyFindingsSideDrawerService } from '@uigy/modules/findings/components/findings-side-panel/services/policy-findings-side-drawer.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TabsUrlParametersService } from '@uigy/shared/services/url-params/tabs-url-parameters.service';

@Component({
  selector: 'app-findings-side-panel',
  imports: [
    UiDrawerComponent,
    UiDrawerContentHeaderComponent,
    UiDrawerSectionComponent,
  ],
  templateUrl: './findings-side-panel.component.html',
  styleUrl: './findings-side-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FindingsSidePanelComponent {

  public vulnerabilityFindingsSideDrawerService = inject(VulnerabilityFindingsSideDrawerService);
  public policyFindingsSideDrawerService = inject(PolicyFindingsSideDrawerService);
  private languageService = inject(LanguageService);
  private tabsUrlParametersService = inject(TabsUrlParametersService);
  public readonly findingsTexts = this.languageService.texts.findings;

  protected readonly ActionButtonVariant = ActionButtonVariant;
  protected readonly TabQueryParams = FindingsTabQueryParams;


  public getCurrentTab(): FindingsTabQueryParams | undefined {
    return this.tabsUrlParametersService.getCurrentTabValue(TabGroup.FindingsTab) as FindingsTabQueryParams;
  }

  public onPolicyDrawerTabChanged(event: MatTabChangeEvent): void {
    this.policyFindingsSideDrawerService.onTabChanged(event);
  }

}
